import { action, makeObservable, observable } from 'mobx';
import { ReactElement } from 'react';

export type Notice = {
    title: string;
    iconColor: string;
    body: ReactElement;
};

export type NoticeInstance = Notice & {
    id: number;
};

export default class NotificationStore {
    @observable
    notices: NoticeInstance[] = [];

    lastToastId = 0;

    constructor() {
        makeObservable(this);
    }

    @action
    addNotice(notice: Notice, timeOutSec = 8): NoticeInstance {
        const instance = { ...notice, id: this.lastToastId++ };
        this.notices = [...this.notices, instance];
        // Handle auto close
        if (timeOutSec > 0) {
            setTimeout(() => this.removeNotification(instance), timeOutSec * 1000);
        }
        return instance;
    }

    @action
    removeNotification(notice: NoticeInstance) {
        this.notices = this.notices.filter((t) => t.id !== notice.id);
    }
}
